package com.gsb.vyapar.bhagya.interactor.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.gsb.vyapar.bhagya.datasource.cache.SqlDelightClient.initDatabase
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.manager.StateManager

class MainViewModel(deepLink: String? = null) : ViewModel(){
    val stateManager: StateManager = StateManager

    init {
        stateManager.setViewModelScope(viewModelScope)
        stateManager.setDeepLink(deepLink)
        initDatabase()
    }

    fun onTriggerEvent(mainUiEvent: UiEvents) {
        stateManager.onTriggerEvent(mainUiEvent)
    }
}